import { User, GlobalRights } from '@reporting/rp-types/core';
import { Service } from './service';

export class UserProvider {

	private _id: string;
	get id() { return this._id }
	set id(id: string) {
		if (this._id != id) {
			this._id = id;
			this._user = null;
			this._rights = null;
			this._groupAdmin = false;
		}
	}

	private _user: User;
	get user() { return this._user }
	set user(v: User) {
		this._user = v;
		if (v && v.user_name != this._id) {
			this._id = v?.user_name;
			this._rights = null;
			this._groupAdmin = false;
		}
	}

	private _rights: string[];
	getRights() {
		return this._rights;
	}

	setRights(rights: string[]) {
		this._rights = rights;
	}

	hasRight(right: string|string[]): boolean {
		if (Array.isArray(right)) return right.some(r => this.hasRight(r));
		return !!this._rights?.includes(right);
	}

	isSA(): boolean {
		return !!this._rights?.includes(GlobalRights.SA);
	}

	private _groupAdmin = false;

	/**
	 * Whether the user administers every accounting of the current group (group-level objects are
	 * theirs to edit), as reported by the session. False until the session is loaded.
	 */
	isGroupAdmin(): boolean {
		return this._groupAdmin;
	}

	setGroupAdmin(v: boolean) {
		this._groupAdmin = !!v;
	}

	isGuest(): boolean {
		return (this._id ?? 'guest') == 'guest';
	}

	async loadUser() {
		this.user = await this.client.get<User>('/me');
	}

	async loadRights() {
		if (this.id) this._rights = await this.client.get<string[]>('userRights');
		//console.log('User rights', this.id, this._rights);
	}

	constructor(private client: Service) { }

	public impersonator: string;
	public impersonator_dv: string;

}
